import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dialog-custom__header" }
const _hoisted_2 = { class: "dialog-custom__title" }
const _hoisted_3 = { class: "dialog-custom__content form-custom" }
const _hoisted_4 = { style: {"height":"calc(100vh - 300px)"} }
const _hoisted_5 = { class: "p-field" }
const _hoisted_6 = { class: "p-field-label mb-3" }
const _hoisted_7 = { class: "list-blocks" }
const _hoisted_8 = { class: "form-custom d-flex align-items-center w-100" }
const _hoisted_9 = { class: "p-field mr-4" }
const _hoisted_10 = { class: "p-field-label" }
const _hoisted_11 = { class: "d-flex flex-column" }
const _hoisted_12 = { class: "dialog-custom__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_CardContainer = _resolveComponent("CardContainer")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", _hoisted_1, [
      _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("AppResourceEP.AddGates")), 1)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_ElScrollbar, { class: "dialog-scroll" }, {
          default: _withCtx(() => [
            _createVNode("div", null, [
              _createVNode("div", _hoisted_5, [
                _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("AppResourceEP.SetupNumberOfGates")), 1)
              ]),
              (_ctx.plant.gates)
                ? (_openBlock(), _createBlock(_component_CardContainer, {
                    key: 0,
                    titleIcon: require(`@/assets/images/entrancePlants/icon-gate.svg`),
                    title: _ctx.titleCard,
                    showActionButton: true,
                    onOnActionButtonClick: _ctx.addGate,
                    disabled: _ctx.reachedMaxGates,
                    actionButtonLabel: _ctx.$t('AppResource.Add')
                  }, {
                    default: _withCtx(() => [
                      _createVNode("ul", _hoisted_7, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.plant.gates, (gate, i) => {
                          return (_openBlock(), _createBlock("li", {
                            class: "new-building",
                            key: i
                          }, [
                            _createVNode("form", _hoisted_8, [
                              _createVNode("div", _hoisted_9, [
                                _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("AppResourceEP.Name")) + ": ", 1),
                                _createVNode("div", _hoisted_11, [
                                  _createVNode(_component_InputText, {
                                    type: "text",
                                    class: "w-100",
                                    modelValue: gate.name,
                                    "onUpdate:modelValue": ($event: any) => (gate.name = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ])
                              ]),
                              _createVNode(_component_Button, {
                                disabled: _ctx.plant.gates.length == 1,
                                label: _ctx.$t('AppResource.Delete'),
                                class: "ml-auto p-button-text",
                                onClick: ($event: any) => (_ctx.handleGateRemove(i))
                              }, null, 8, ["disabled", "label", "onClick"])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }, 8, ["titleIcon", "title", "onOnActionButtonClick", "disabled", "actionButtonLabel"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode("footer", _hoisted_12, [
      _createVNode(_component_Button, {
        onClick: _ctx.handleBackButton,
        label: _ctx.$t('AppResource.Back'),
        class: "p-button-text mr-3"
      }, null, 8, ["onClick", "label"]),
      _createVNode(_component_Button, {
        onClick: _ctx.handleNextButton,
        label: _ctx.$t('AppResource.Continue'),
        class: "p-button-rounded p-button-raised p-button--m"
      }, null, 8, ["onClick", "label"])
    ])
  ], 64))
}